import { createAction } from 'redux-actions'

export const types = {
    ASSIGN_AFFILIATION_SETTINGS: 'affiliation/ASSIGN_AFFILIATION_SETTINGS',
    POPULATE_AFFILIATION_DATA: 'affiliation/POPULATE_AFFILIATION_DATA',
}

export const actions = {
    assignAffiliationSettings: createAction<AffiliationSettingsDto>(types.ASSIGN_AFFILIATION_SETTINGS),
    populateAffiliationData: createAction<AffiliationDataRecord[]>(types.POPULATE_AFFILIATION_DATA),
}
